const types = {
  SET_CURRENT_ORGANIZATION: 'SET_CURRENT_ORGANIZATION'
};
const state = {
  currentOrganization: null
};

const mutations = {
  [types.SET_CURRENT_ORGANIZATION]: (state, value) => {
    state.currentOrganization = value;
  },
};

const actions = {};
const getters = {};

export default {
  namespaced: true,
  types,
  state,
  mutations,
  actions,
  getters
};
